import { useMemo } from 'react'

import useSiteMetadata from '../../../hooks/useSiteMetadata'

interface TestKitProducts {
  skus: string[]
  processingSkus: string[]
}

export interface UseTestKitProducts {
  isTestKitSku: (sku: string) => boolean
  isProcessingSku: (sku: string) => boolean
}

export const useTestKitProducts = (): UseTestKitProducts => {
  const siteMetadata = useSiteMetadata()

  return useMemo(() => {
    const testKitProducts = (siteMetadata?.testKitProducts ?? []).reduce<TestKitProducts>(
      (acc, { sku, processingSku }) => {
        acc.skus.push(sku)
        if (processingSku) {
          acc.processingSkus.push(processingSku)
        }
        return acc
      },
      { skus: [], processingSkus: [] },
    )

    const isTestKitSku = (sku: string) =>
      testKitProducts.skus.some((testKitSku) => testKitSku === sku)
    const isProcessingSku = (sku: string) =>
      testKitProducts.processingSkus.some((processingSku) => processingSku === sku)

    return {
      isTestKitSku,
      isProcessingSku,
    }
  }, [siteMetadata])
}
